import {Grid, TextField} from "@mui/material";

export const CampaignDetailsFields = ({form, errors, setField}) => {
  return (
    <>
      <Grid item xs={12} md={9}>
        <TextField label="Name" fullWidth required size="small" value={form.name} onChange={setField("name")}/>
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          label="Max attempts" type="number" fullWidth required size="small"
          inputProps={{min: 1}}
          value={form.maxAttempts} onChange={setField("maxAttempts")}
          error={!!errors.maxAttempts}
          helperText={errors.maxAttempts || "Maximum calls per number, until it is reached"}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Description" fullWidth multiline minRows={2} size="small"
          inputProps={{maxLength: 2048}}
          value={form.description} onChange={setField("description")}
        />
      </Grid>
    </>
  )
}
